import React from "react";
import "./About.css";
import cv from "../../assets/Zaid Rajab_Full Stack.pdf";

const skillsData = {
  frontend: [
    {
      src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/html5/html5-original.svg",
      alt: "HTML",
      label: "HTML",
    },
    {
      src: "https://raw.githubusercontent.com/devicons/devicon/master/icons/css3/css3-original.svg",
      alt: "CSS",
      label: "CSS",
    },
    {
      src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/javascript/javascript-plain.svg",
      alt: "Js",
      label: "JavaScript",
    },
    {
      src: "https://thesvg.org/icons/angular/default.svg",
      alt: "Angular",
      label: "Angular",
    },
    {
      src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/tailwindcss/tailwindcss-original.svg",
      alt: "Tailwind",
      label: "Tailwind",
    },
    {
      src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/bootstrap/bootstrap-original.svg",
      alt: "Bootstrap",
      label: "Bootstrap",
    },
    {
      src: "https://img.icons8.com/?size=100&id=13664&format=png&color=000000",
      alt: "WordPress",
      label: "WordPress",
    },
    {
      src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/react/react-original.svg",
      alt: "React",
      label: "React",
    },
    {
      src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/redux/redux-original.svg",
      alt: "Redux",
      label: "Redux",
    },
    {
      src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/flutter/flutter-original.svg",
      alt: "Flutter",
      label: "Flutter",
    },
  ],
  backend: [
    {
      src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/dotnetcore/dotnetcore-original.svg",
      alt: ".Net Core",
      label: ".Net Core",
    },
    {
      src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/nodejs/nodejs-original.svg",
      alt: "Nodejs",
      label: "NodeJs",
    },
    {
      src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/microsoftsqlserver/microsoftsqlserver-original-wordmark.svg",
      alt: "SQLServer",
      label: "SQLServer",
    },
    {
      src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/postgresql/postgresql-original-wordmark.svg",
      alt: "PostgreSQL",
      label: "PostgreSQL",
    },
    {
      src: "https://icon.icepanel.io/Technology/svg/RabbitMQ.svg",
      alt: "RabbitMQ",
      label: "RabbitMQ",
    },
    {
      src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/firebase/firebase-original.svg",
      alt: "Firebase",
      label: "Firebase",
    },
  ],
  tools: [
    {
      src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/docker/docker-original.svg",
      alt: "Docker",
      label: "Docker",
    },
    {
      src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/jira/jira-original.svg",
      alt: "Jira",
      label: "Jira",
    },
    {
      src: "https://cdn.jsdelivr.net/gh/devicons/devicon@latest/icons/canva/canva-original.svg",
      alt: "Canva",
      label: "Canva",
    },
    {
      src: "https://cdn.jsdelivr.net/gh/devicons/devicon/icons/git/git-original.svg",
      alt: "git",
      label: "Git",
    },
    {
      src: "https://raw.githubusercontent.com/lobehub/lobe-icons/refs/heads/master/packages/static-png/dark/cursor.png",
      alt: "Cursor",
      label: "Cursor",
    },
  ],
};

const About = () => (
  <section className="sobre-mi" id="about-me">
    <h2 className="heading">About me</h2>

    <div className="row">
      <div className="columns" data-aos="fade-up" data-aos-delay="300">
        <p>
          I'm a Software Developer with over 2 years of hands-on experience
          building scalable web applications using modern technologies.
        </p>
        <p>
          Currently a Full Stack Developer at Al Watania Information Systems, I
          work on enterprise platforms with ASP.NET Core and Angular, applying
          Clean Architecture, CQRS, and SOLID principles. Previously, as a
          Frontend Developer at Taqneen Software, I contributed to digitalizing
          JFDA operations using Angular, reusable components, and RESTful APIs.
        </p>
        <p>
          My skills span ASP.NET Core, Angular, React.js, SQL, Tailwind, and
          more. I thrive on managing multiple tasks, collaborating within
          cross-functional teams, mentoring newcomers, and delivering clean,
          maintainable code that drives real impact.
        </p>
        <div className="mas-info">
          <a
            href={cv}
            target="_blank"
            rel="noopener noreferrer"
            download="Zaid Rajab Resume.pdf"
            className="btn-codigo download-button"
          >Download CV
          </a>
        </div>
      </div>
      <div
        className="columns col-skill"
        data-aos="fade-up"
        data-aos-delay="650"
      >
        <h3>Skills</h3>

        <div className="bg">
          <h4>Front-End</h4>
          <div className="skill">
            {skillsData.frontend.map((skill, index) => (
              <div key={index}>
                <img alt={skill.alt} className="icons-skils" src={skill.src} />
                <h5>{skill.label}</h5>
              </div>
            ))}
          </div>
        </div>

        <div className="bg">
          <h4>Back-End</h4>
          <div className="skill">
            {skillsData.backend.map((skill, index) => (
              <div key={index}>
                <img alt={skill.alt} className="icons-skils" src={skill.src} />
                <h5>{skill.label}</h5>
              </div>
            ))}
          </div>
        </div>

        <div className="bg">
          <h4>Tools</h4>
          <div className="skill">
            {skillsData.tools.map((tool, index) => (
              <div key={index}>
                <img alt={tool.alt} className="icons-skils" src={tool.src} />
                <h5>{tool.label}</h5>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
 
export default React.memo(About);
